import React from "react"
import classnames from "classnames"
import styled from "styled-components"
import { MyLoading } from "@macashipo/mlib"
import BouncingDotsLoader from "./BouncingDotsLoader"

interface IProps {
  className?: string
  classNameEmpty?: string
  isLoading?: boolean
  isEmpty?: boolean
  isError?: boolean
  msgEmpty?: string
  msgError?: string
  children?: any
  showLoadingIcon?: boolean
}
const MyUIWLoadingOverlay = (props: IProps) => {
  const { className, isLoading, showLoadingIcon, children } = props

  const renderLoadingOverlay = () => {
    // if (isLoading) {
    return (
      <Loading className={isLoading && "show"}>
        <div className="a-overlay">
          {showLoadingIcon && <BouncingDotsLoader />}
        </div>
      </Loading>
    )
    // }
  }
  const renderMain = () => {
    return children
  }
  return (
    <Wrap className={classnames("myui-wrap-loading-overlay", className)}>
      {renderMain()}
      {renderLoadingOverlay()}
    </Wrap>
  )
}
const Loading: any = styled.div`
  display: none;
  &.show {
    display: unset;
  }
  & .a-overlay {
    & > div {
      & div {
        width: 9px;
        height: 9px;
      }
    }
  }
`
const Wrap = styled.div``
export default MyUIWLoadingOverlay
